import React, { useState, useEffect } from 'react';
import SRCards from '../../components/SRCards';
import AddPaymentLinkApi from '../../services/payment.service';
import history from '../../services/history.service';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import InfoIcon from '@material-ui/icons/Info';
import {
  Container, Dialog, DialogActions, DialogContent, DialogTitle,
  Tooltip, Typography, IconButton, Snackbar
} from '@material-ui/core';
import {
  CHECK_NON_EMPTY_DICTIONARY
} from '../../common/data-validator'
import { Alert } from '@material-ui/lab';

const apiservices = new AddPaymentLinkApi();
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }),
);


export default function AddPaymentLink() {


  const [webToken, setWebToken] = useState('');
  const [apiKey, setApiKey] = useState('')
  const [fattMerchantDetails, setFattMerchantDetails]: any = useState({});
  const [gravityDetails, setGravityDetails]: any = useState({})
  const [gatewayUrl, setGatewayUrl] = useState('')
  const [pin, setPin] = useState('')
  const [sourceKey, setSourceKey] = useState('')
  const [dialog, setDialog] = useState('');
  const [snackBar, setSnackBar] = useState('');
  const [pageResponse, setPageResponse] = useState('');
  const [gatewayUrlError, setGatewayUrlError] = useState('');
  const [pinError, setPinError] = useState('');
  const [sourceKeyError, setSourceKeyError] = useState('');
  const [apiKeyError, setApiKeyError] = useState('');
  const classes = useStyles();

  let res: any;

  let responses: any;
  useEffect(() => {
      // eslint-disable-next-line
    responses = async () => {
        // eslint-disable-next-line
      res = await apiservices.getDetails();
    }
    onRender();
  }, [])
  const onRender = async () => {
    await responses();
    validate(res)
  }

  const validate = (data: any) => {
    if (CHECK_NON_EMPTY_DICTIONARY(data)) {
      if ((data.gravity && data.gravity.isActive) &&
        (data.fattMerchant && data.fattMerchant.isActive)) {
        setDialog('Only one method should be Active');
      } else if (data.gravity.isActive) {
        setGravityDetails(data.gravity)
        setGatewayUrl(data.gravity.paymentGatewayURLGravity || '')
        setPin(data.gravity.paymentPinGravity || '')
        setSourceKey(data.gravity.paymentSourceKeyGravity || '')
      } else if (data.fattMerchant.isActive) {
        setFattMerchantDetails(data.fattMerchant)
        setApiKey(data.fattMerchant.fattmerchantAPIKey || '')
        if (data.fattMerchant.fattWebPaymentToken) {
          setWebToken(data.fattMerchant.fattWebPaymentToken || '')
        }
      } else {
        setDialog('Add method from SmartServ CRM before adding links or check if it is Active');
      }
    } 
  }

  const onSubmit = async () => {
    let paymentDetails: any = {}, response;
    if(gatewayUrl === '' && (gravityDetails &&
      gravityDetails.isActive &&
      !gravityDetails.paymentGatewayURLGravity)) {
      setGatewayUrlError('Gateway URL required');
    } else if(pin === '' && (gravityDetails &&
      gravityDetails.isActive &&
      !gravityDetails.paymentGatewayURLGravity)){
      setPinError('Pin is required');
    } else if(sourceKey === '' && (gravityDetails &&
      gravityDetails.isActive &&
      !gravityDetails.paymentGatewayURLGravity)){
      setSourceKeyError('Source Key is required');
    } else if(apiKey === '' && (fattMerchantDetails &&
      fattMerchantDetails.isActive &&
      !fattMerchantDetails.fattmerchantAPIKey)) {
       setApiKeyError('Api Key is requried')
    } else {
      if (gatewayUrl !== '' && pin !== '' && sourceKey !== '') {
        setGatewayUrlError('');
        setPinError('');
        setSourceKeyError('')
        paymentDetails.gravity = {
          id: gravityDetails.id,
          paymentGatewayURLGravity: gatewayUrl,
          paymentPinGravity: pin,
          paymentSourceKeyGravity: sourceKey,
          paymentType: gravityDetails.paymentType.id,
          name: gravityDetails.name,
          isActive: gravityDetails.isActive,
          collation: gravityDetails.collation
        };
        response = await apiservices.putData(paymentDetails);
      } else if (apiKey !== '') {
        setApiKeyError('')
        paymentDetails.fattMerchant = {
          id: fattMerchantDetails.id,
          fattmerchantAPIKey: apiKey,
          paymentType: fattMerchantDetails.paymentType.id,
          name: fattMerchantDetails.name,
          isActive: fattMerchantDetails.isActive,
          collation: fattMerchantDetails.collation
        };
        if (webToken !== '') {
          paymentDetails.fattMerchant.fattWebPaymentToken = webToken;
        }
        response = await apiservices.putData(paymentDetails);
      }
    }
    if (response && 
      ((response.gravity && response.gravity.paymentGatewayDetailsId) || 
      (response.fattMerchant && response.fattMerchant.paymentGatewayDetailsId))) {
      setSnackBar('success');
      setPageResponse('Added Successfully.')
        res = await apiservices.getDetails();
        validate(res);
      }
    else {
        let msg;
        if(response && response.message && response.description) {
            msg = `Request Failed: ${response.message} - ${response.description}`
        } else {
            msg = `Request Failed.`
        }
        setSnackBar('error');
        setPageResponse(msg);
    }
      
    
  }
  return (

    <div>
      <SRCards />
      <Container>
        <Snackbar
          open={snackBar === '' ? false : true}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackBar('');
          }}
        >
          <Alert
            severity={snackBar === 'success'?'success':'error'}
            onClose={() => {
              setSnackBar('')
            }
            }>
            {pageResponse}
          </Alert>
        </Snackbar>
        <Typography
          style={{
            padding: 16
          }}
        >
          {localStorage.getItem('selectedCompanyDisplay')}
        </Typography>
        <form className={classes.root} noValidate autoComplete="off">
          <Typography>Fatt Merchant</Typography>
          <TextField
            id="outlined-full-width"
            label="APIKey"
            variant="outlined"
            fullWidth
            disabled={
              fattMerchantDetails &&
                fattMerchantDetails.isActive &&
                !fattMerchantDetails.fattmerchantAPIKey ?
                false :
                true
            }
            required
            error={apiKeyError === '' ? false : true}
            helperText={apiKeyError}
            value={apiKey}
            onChange={(e) => { setApiKey(e.target.value) }}

          />
          <TextField
            id="outlined-basic"
            label="Web Token"
            variant="outlined"
            style={{ width: 500 }}
            disabled={
              fattMerchantDetails &&
                fattMerchantDetails.isActive &&
                !fattMerchantDetails.fattmerchantAPIKey ?
                false :
                true
            }
            value={webToken}
            onChange={(e) => { setWebToken(e.target.value) }}

          />

          <Divider />
          <Typography>Gravity</Typography>
          <TextField
            id="outlined-basic"
            label="Payment Gateway URL"
            variant="outlined"
            style={{ width: 500 }}
            disabled={
              gravityDetails &&
                gravityDetails.isActive &&
                !gravityDetails.paymentGatewayURLGravity ?
                false :
                true
            }
            required
            error={gatewayUrlError === '' ? false : true}
            helperText={gatewayUrlError}
            value={gatewayUrl}
            onChange={(e) => { setGatewayUrl(e.target.value) }}

          />

          <TextField
            id="outlined-basic"
            label="Payment Pin"
            variant="outlined"
            style={{ width: 200 }}
            disabled={
              gravityDetails &&
                gravityDetails.isActive &&
                !gravityDetails.paymentGatewayURLGravity ?
                false :
                true
            }
            required
            error={pinError === '' ? false : true}
            helperText={pinError}
            value={pin}
            onChange={(e) => { setPin(e.target.value) }}
          />
          <TextField
            id="outlined-basic"
            label="Payment Source Key"
            variant="outlined"
            style={{ width: 400 }}
            disabled={
              gravityDetails &&
                gravityDetails.isActive &&
                !gravityDetails.paymentGatewayURLGravity ?
                false :
                true
            }
            required
            error={sourceKeyError === '' ? false : true}
            helperText={sourceKeyError}
            value={sourceKey}
            onChange={(e) => { setSourceKey(e.target.value) }}
          />
          <Divider />
          <Tooltip
            title={<React.Fragment>
              <Typography>
                1. In case you are not able to edit the empty fields,
                  make sure you have added the payment method from SmartServ CRM
                  and is Active. <br />
                2. In case you are not able to Submit the details,
                  make sure only one of the payment methods is Active.
              </Typography>
            </React.Fragment>}>
            <IconButton color='inherit'>
              <InfoIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="contained"
            color="primary"
            disabled={
              (gravityDetails.paymentGatewayURLGravity ||
                fattMerchantDetails.fattmerchantAPIKey)
            }
            onClick={onSubmit}
          >
            Submit
      </Button>
        </form>
        <Dialog
          open={dialog === '' ? false : true}
          onClose={() => {
            setDialog('')
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {'Cannot Add Links!'}
          </DialogTitle>
          <DialogContent>
            {dialog}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => { 
                setDialog(''); 
                history.push('/');
              }}
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  );
}
